// http.js
import axios from 'axios'

// get 请求
export function httpGet({
  url,
  params = {}
}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then((res) => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// post请求
export function httpPost({
  url,
  data = {},
  params = {}
}) {
  return axios({
    url,
    method: 'post',
    // transformRequest: [function (data) {
    //   data = JSON.stringify(data);
    //   return data
    // }],
    headers: {
      'Content-Type': 'application/json'
    },
    // 发送的数据
    data,
    // url参数
    params
  })
}
// post图片请求
export function httpImgPost({
  url,
  data = {},
  params = {}
}) {
  return axios({
    url,
    method: 'post',
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    timeout: 300000,
    // 发送的数据
    data,
    // url参数
    params
  })
}
// post文件接收
export function httpFilePost({
  url,
  data = {},
  params = {}
}) {
  return axios({
    url,
    method: 'post',
    // 发送的数据
    transformRequest: [function (data) {
      data = JSON.stringify(data);
      return data
    }],
    timeout: 300000,
    data,
    responseType: 'blob',
    // url参数
    params
  })
}



// WEBPACK FOOTER //
// ./src/http.js